"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetParts = exports.deleteManyParts = exports.deletedOnePart = exports.updatedManyParts = exports.updatedOnePart = exports.gotManyParts = exports.gotOnePart = void 0;
var index_1 = __importDefault(require("./index"));
var _a = index_1.default.actions, gotOne = _a.gotOne, gotMany = _a.gotMany, updatedOne = _a.updatedOne, updatedMany = _a.updatedMany, deletedOne = _a.deletedOne, deleteMany = _a.deleteMany, reset = _a.reset;
exports.gotOnePart = gotOne;
exports.gotManyParts = gotMany;
exports.updatedOnePart = updatedOne;
exports.updatedManyParts = updatedMany;
exports.deletedOnePart = deletedOne;
exports.deleteManyParts = deleteMany;
exports.resetParts = reset;
//# sourceMappingURL=actions.js.map